import { BILLING_CYCLE, PlanModelInfo, planTypes } from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { divisions } from '@/plans/ZOOM_PHONE/helper/constants';
import { getCartInfo } from "@/common/service/default-mapper";
import _ from 'lodash';
import { PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import { additionalConfigType } from "../ZOOM_PHONE$ADDITIONAL/helper";

export default (planMapJSON) => {
  const pbxPlans = _.concat(planMapJSON.pbxAudio?.pbx?.plans || [], planMapJSON.pbxAudio?.smbInfo?.pbx?.plans || []);
  return pbxPlans
  .filter(item => !['ZPI', 'ZPA'].includes(item.category_code))
  .filter(item => !additionalConfigType.supportAdditionalSubTypes.includes(item.sub_type) || additionalConfigType.region !== item.region)
  .map((item) => {
    return {
      type: planTypes.ZOOM_PHONE,
      category: item.category_code,
      region: item.region,
      division: divisions?.find(division => division.category === item.category_code)?.key || '',
      sub_type: item.sub_type,
      pbx_sub_type: item.sub_type,
      parent_category: 'ZMV',
      plan_code: item.plan_code,
      free_trial_pc: item.free_trial_pc,
      plan_type: item.plan_type,
      amount: item.amount,
      unit: item.sub_type == PBX_SUB_TYPES.PHONE_NUMBER && planUnitMap.number || planUnitMap.calling,
      cartInfo: getCartInfo(),
      billing_cycle: item.is_payg ? BILLING_CYCLE.PAY_AS_YOU_GO : item.billing_cycle,
      is_payg: item.is_payg,
      typeNameKey: "billing.planform.title.zoomphone",
      planNameKey: `billing.pbx.plan_name.${item.category_code}`,
      planCartNameKey: `billing.pbx.cart_name.${item.category_code}`,
      dependBasePlanTypeList: [],
      supportCoupon: true,
      planModel: item.is_payg ? PlanModelInfo.usage : PlanModelInfo.license
    };
  });
}
